import { GatsbyImage } from "gatsby-plugin-image";
import React, { FC } from "react";

import { RichText } from "../../../rich-text";
import { Tag } from "../../../tag";

export interface HeaderMenuCardProps extends Queries.HeaderMenuCardDataFragment {}

export const HeaderMenuCard: FC<HeaderMenuCardProps> = ({ body, title, tag, image }) => {
  const hasInfo = Boolean(body ?? title ?? tag);
  return (
    <div className="flex justify-between overflow-hidden relative bg-light h-full rounded-xl w-fit">
      {hasInfo && (
        <div className="flex-none w-48 flex flex-col px-3 py-4">
          {tag && <Tag className="whitespace-nowrap truncate w-fit max-w-full">{tag}</Tag>}
          {title && <div className="font-bold text-xl flex-1 flex items-end">{title}</div>}
          {body?.raw && <RichText className="line-clamp-5" raw={body.raw} />}
        </div>
      )}
      {image?.gatsbyImageData && (
        <GatsbyImage alt="" objectFit="cover" image={image.gatsbyImageData} />
      )}
    </div>
  );
};
